import React, { useState, useEffect } from "react";
import moment from 'moment';
import 'moment-timezone';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { Collapse, Typography, Divider, message, Row, Col, Spin } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { FetchUserDetails } from "../../../../Api/Services/UserApiService"
import { FetchAccountDetails } from "../../../../Api/Services/AccountApiService"
import { FetchContactDetails } from "../../../../Api/Services/ContactApiService"
import { FetchDealDetails } from "../../../../Api/Services/DealApiService"
import { FetchQuoteDetails } from "../../../../Api/Services/QuotesApiService"
import { FetchSalesOrderDetails } from "../../../../Api/Services/SalesOrderApiService"
import { ExchangeCurrency } from '../../Filters/FilterConditions';
import { StaffIcon } from '../../../../components/Icons/Icons';
import { RelatedDocs } from '../GlobalComponents/RelatedDocUpload';
import { UserSideDiv } from '../GlobalComponents/UserCardCmnts';

const { Panel } = Collapse;
const { Text } = Typography;

const NoteDetails = ({ displayData, profile, ViewDetailPage, currencySettings }) => {
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const [userData, setUserData] = useState()
    const [accountData, setAccountData] = useState()
    const [dealData, setDealData] = useState()
    const [contactData, setContactData] = useState()
    const [quoteData, setQuoteData] = useState()
    const [salesOrderData, setSalesOrderData] = useState()
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen5, setIsOpen5] = useState(false);
    const [isOpen6, setIsOpen6] = useState(true);
    const [isOpen7, setIsOpen7] = useState(true);
    const [isOpen4, setIsOpen4] = useState(false);
    const [isOpen3, setIsOpen3] = useState(false);
    const handleExpand2 = (key) => {
        setIsOpen2(key.length > 0);
    };
    const handleExpand = (key) => {
        setIsOpen(key.length > 0);
    };
    const handleExpand3 = (key) => {
        setIsOpen3(key.length > 0);
    };
    const handleExpand4 = (key) => {
        setIsOpen4(key.length > 0);
    };
    const handleExpand5 = (key) => {
        setIsOpen5(key.length > 0);
    };
    const handleExpand6 = (key) => {
        setIsOpen6(key.length > 0);
    };
    const handleExpand7 = (key) => {
        setIsOpen7(key.length > 0);
    };
    async function getAccountData(params) {
        try {
            const responseData = await FetchAccountDetails(params)
            const Response = responseData.data
            const merged = { ...Response, DataPermission: { isPresent: responseData.allow }, };
            setAccountData(merged)
        } catch (error) {
            message.error(error)
        }
    }
    async function getDealData(params) {
        try {
            const ConvertRates = currencySettings?.exchangeRate;
            const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
            const dealresponse = await FetchDealDetails(params)
            const Response = dealresponse.data
            const DealValue = Response.deal_value ? await ExchangeCurrency(Number(Response.deal_value), ConvertRates) : Response.deal_value;
            const GrossDealValue = Response.gross_deal_value ? await ExchangeCurrency(Number(Response.gross_deal_value), ConvertRates) : Response.gross_deal_value;
            const ForecastedValue = Response.forecasted_value ? await ExchangeCurrency(Number(Response.forecasted_value), ConvertRates) : Response.forecasted_value;
            const updatedPerson = {
                ...Response,
                gross_deal_value: Number(GrossDealValue?.toFixed(CurencyDecimalPlace)),
                deal_value: Number(DealValue?.toFixed(CurencyDecimalPlace)),
                forecasted_value: Number(ForecastedValue?.toFixed(CurencyDecimalPlace)),
                DataPermission: { isPresent: dealresponse.allow }
            };
            setDealData(updatedPerson)
        } catch (error) {
            message.error(error)
        }
    }
    async function getContactData(params) {
        try {
            const responseData = await FetchContactDetails(params)
            const Response = responseData.data
            const merged = { ...Response, DataPermission: { isPresent: responseData.allow }, };
            setContactData(merged);
        } catch (error) {
            message.error(error);
        }
    }
    async function getQuoteData(params) {
        try {
            const ConvertRates = currencySettings?.exchangeRate;
            const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
            const Response = await FetchQuoteDetails(params)
            const total = Response.data.quotesItem?.grandTotalamount
                ? await ExchangeCurrency(Number(Response.data.quotesItem?.grandTotalamount), ConvertRates)
                : Response.data.quotesItem.grandTotalamount;
            const updatedPerson = {
                ...Response.data,
                total_value: Number(total?.toFixed(CurencyDecimalPlace)),
                DataPermission: { isPresent: Response.allow }
            };
            setQuoteData(updatedPerson);
        } catch (error) {
            message.error(error);
        }
    }
    async function getSalesOrderData(params) {
        try {
            const ConvertRates = currencySettings?.exchangeRate;
            const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
            const Response = await FetchSalesOrderDetails(params)
            const total = Response.data.salesOrderItem?.grandTotalamount
                ? await ExchangeCurrency(Number(Response.data.salesOrderItem?.grandTotalamount), ConvertRates)
                : Response.data.salesOrderItem.grandTotalamount;
            const updatedPerson = {
                ...Response.data,
                total_value: Number(total?.toFixed(CurencyDecimalPlace)),
                DataPermission: { isPresent: Response.allow }
            };
            setSalesOrderData(updatedPerson);
        } catch (error) {
            message.error(error);
        }
    }
    async function getUsersData(params) {
        try {
            const Response = await FetchUserDetails(params)
            setUserData(Response?.data)
        } catch (error) {
            message.error(error)
        }
    }
    useEffect(() => {
        if (isOpen2) {
            if (displayData?.invoiceOwner) {
                getUsersData(displayData?.invoiceOwner)
            } else {
                setUserData()
            }
        }
    }, [displayData?.invoiceOwner, isOpen2])
    useEffect(() => {
        if (isOpen4) {
            if (displayData?.dealId) {
                getDealData(displayData?.dealId)
            } else {
                setDealData()
            }
        }
    }, [displayData?.dealId, isOpen4])
    useEffect(() => {
        if (isOpen5) {
            if (displayData?.conatctId) {
                getContactData(displayData?.conatctId)
            } else {
                setContactData()
            }
        }
    }, [displayData?.conatctId, isOpen5])
    useEffect(() => {
        if (isOpen3) {
            if (displayData?.accountId) {
                getAccountData(displayData?.accountId)
            } else {
                setAccountData()
            }
        }
    }, [displayData?.accountId, isOpen3])
    useEffect(() => {
        if (isOpen6) {
            if (displayData?.quoteId) {
                getQuoteData(displayData?.quoteId)
            } else {
                setQuoteData()
            }
        }
    }, [displayData?.quoteId, isOpen6])
    useEffect(() => {
        if (isOpen7) {
            if (displayData?.salesOrderId) {
                getSalesOrderData(displayData?.salesOrderId)
            } else {
                setSalesOrderData()
            }
        }
    }, [displayData?.salesOrderId, isOpen7])
    return (
        <>
            <Collapse className="DetailsTabCollapse2" bordered={false} defaultActiveKey={["1"]} onChange={handleExpand7} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Tenancy Agreement</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen7 ? "Close" : "View"}</Text></div>} key="1">
                    {salesOrderData ? <div className='RightSide-DataShadow'>
                        <div className={`user-info_image ${salesOrderData?.DataPermission?.isPresent && "ListNavigate"}`}
                            style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }} tabIndex={0} role="button"
                            onClick={salesOrderData?.DataPermission?.isPresent ? () => salesOrderData?.salesOrderId && ViewDetailPage(salesOrderData?.salesOrderId, "SORDER") : undefined}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    ViewDetailPage(salesOrderData?.salesOrderId, "SORDER")
                                }
                            }}
                        >
                            <span className='list_span_Tag' style={{ flexShrink: 0, }}>
                                {salesOrderData?.salesOrderName?.slice(0, 1).toUpperCase()}
                            </span>
                            <figcaption style={{
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden", // 👈 keeps ellipsis responsive
                            }}>
                                <div style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={salesOrderData?.salesOrderName}>{salesOrderData?.salesOrderName}</div>
                                <div style={{
                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={salesOrderData?.salesOrderNumber}>{salesOrderData?.salesOrderNumber}</div>
                            </figcaption>
                        </div>
                        {(salesOrderData?.salesOrderStatus && salesOrderData?.salesOrderStatus !== "") ?
                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Tenancy Agreement Status</Text>
                                <br />
                                <Text >{salesOrderData?.salesOrderStatus}</Text>
                            </div> : <></>}
                        {(salesOrderData?.dueDate && salesOrderData?.dueDate !== "") ?
                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Due Date</Text>
                                <br />
                                <Text >{salesOrderData?.dueDate && profile.dateFormate ? moment(salesOrderData?.dueDate).format(profile.dateFormate) : (salesOrderData?.dueDate && moment(salesOrderData?.dueDate).format("YYYY-MM-DD"))}</Text>
                            </div> : <></>}
                        {(salesOrderData?.total_value && salesOrderData?.total_value !== "") ?
                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Total</Text> <br />
                                <Text >{currencySettings?.symbol} {salesOrderData?.total_value?.toLocaleString()}</Text>
                            </div> : <></>}
                    </div> : <div className='RightSide-DataShadow'>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "10rem"
                        }}>
                            <Spin />
                        </div>
                    </div>}
                </Panel>
            </Collapse >
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} defaultActiveKey={["1"]} onChange={handleExpand6} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Quote</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen6 ? "Close" : "View"}</Text></div>} key="1">
                    {quoteData ? <div className='RightSide-DataShadow'>
                        <div className={`user-info_image ${quoteData?.DataPermission?.isPresent && "ListNavigate"}`}
                            style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }} tabIndex={0} role="button"
                            onClick={quoteData?.DataPermission?.isPresent ? () => quoteData?.quotesId && ViewDetailPage(quoteData?.quotesId, "QUOTES") : undefined}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    ViewDetailPage(quoteData?.quotesId, "QUOTES")
                                }
                            }}
                        >
                            <span className='list_span_Tag' style={{ flexShrink: 0, }}>
                                {quoteData?.quotesName?.slice(0, 1).toUpperCase()}
                            </span>
                            <figcaption style={{
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden", // 👈 keeps ellipsis responsive
                            }}>
                                <div style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={quoteData?.quotesName}>{quoteData?.quotesName}</div>
                                <div style={{
                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={quoteData?.quotesNumber}>{quoteData?.quotesNumber}</div>
                            </figcaption>
                        </div>
                        {(quoteData?.quotesStatus && quoteData?.quotesStatus !== "") ?
                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Quote Status</Text>
                                <br />
                                <Text >{quoteData?.quotesStatus}</Text>
                            </div> : <></>}
                        {(quoteData?.validUntil && quoteData?.validUntil !== "") ?
                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Expiry Date</Text>
                                <br />
                                <Text >{quoteData?.validUntil && profile.dateFormate ? moment(quoteData?.validUntil).format(profile.dateFormate) : (quoteData?.validUntil && moment(quoteData?.validUntil).format("YYYY-MM-DD"))}</Text>
                            </div> : <></>}
                        {(quoteData?.total_value && quoteData?.total_value !== "") ?
                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Total</Text> <br />
                                <Text >{currencySettings?.symbol} {quoteData?.total_value?.toLocaleString()}</Text>
                            </div> : <></>}
                    </div> : <div className='RightSide-DataShadow'>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "10rem"
                        }}>
                            <Spin />
                        </div>
                    </div>}
                </Panel>
            </Collapse >
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand3} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Sponsor</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen3 ? "Close" : "View"}</Text></div>} key="1">
                    {accountData ? <div className='RightSide-DataShadow'>
                        <div className={`user-info_image ${accountData?.DataPermission?.isPresent && "ListNavigate"}`}
                            style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }} tabIndex={0} role="button"
                            onClick={accountData?.DataPermission?.isPresent ? () => accountData?.account_id && ViewDetailPage(accountData?.account_id, "ACCOUNT") : undefined}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    ViewDetailPage(accountData?.account_id, "ACCOUNT")
                                }
                            }}
                        >
                            {accountData?.account_profile !== null && accountData?.account_profile
                                !== undefined && accountData?.account_profile !== "" ?
                                <figure>
                                    <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={accountData?.account_profile} alt="" />
                                </figure>
                                :
                                <span className='list_span_Tag AccountIcon' style={{ flexShrink: 0, }}>
                                    {accountData?.account_name?.slice(0, 1).toUpperCase()}
                                </span>
                            }
                            <figcaption style={{
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden", // 👈 keeps ellipsis responsive
                            }}>
                                <div style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={accountData?.account_name}>{accountData?.account_name}</div>
                                <div style={{
                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={accountData?.account_number}>{accountData?.account_number}</div>
                            </figcaption>
                        </div>
                        <Row gutter={30}>
                            {/* <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                {(accountData?.industry_name && accountData?.industry_name !== "") ?
                                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Industry</Text>
                                        <br />
                                        <Text >{accountData?.industry_name}</Text>
                                    </div> : <></>}</Col> */}
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                {(accountData?.nom_of_employees && accountData?.nom_of_employees !== "") ?
                                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>No of Employees</Text>
                                        <br />
                                        <Text >{accountData?.nom_of_employees}</Text>
                                    </div> : <></>}
                            </Col>
                        </Row>
                        <Row gutter={30}>
                            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                {(accountData?.annual_revenue && accountData?.annual_revenue !== "") ?
                                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Annual Revenue</Text> <br />
                                        <Text >{accountData?.annual_revenue}</Text>
                                    </div> : <></>}</Col>
                            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                {(accountData?.rating && accountData?.rating !== "") ?
                                    <div><Text type="secondary" className='RightSide-Lable'>Rating</Text> <br />
                                        <Text >{accountData?.rating}</Text>
                                    </div> : <></>}
                            </Col>
                        </Row>
                        {accountData?.account_owner &&
                            <div><Text type="secondary" className='RightSide-Lable'>Sponsor Owner</Text> <br />
                                <Text >
                                    <div className={`user-info_image ${(Role === "Administrator" || profile.userId === accountData?.account_owner) && "ListNavigate"}`}
                                        role="button" style={{ padding: "5px 0px 0px", display: "flex", alignItems: "center", minWidth: 0, }}
                                        tabIndex={0}
                                        onClick={(Role === "Administrator" || profile.userId === accountData?.account_owner) ? () => accountData?.account_owner && ViewDetailPage(accountData?.account_owner, "USER") : undefined}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter' || event.key === ' ') {
                                                ViewDetailPage(accountData?.account_owner, "USER");
                                            }
                                        }}> {accountData?.userProfilePic !== null && accountData?.userProfilePic
                                            !== undefined && accountData?.userProfilePic !== "" ?
                                            <figure>
                                                <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={accountData?.userProfilePic} alt="" />
                                            </figure>
                                            :
                                            <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                                                {accountData?.userFirstName?.slice(0, 1).toUpperCase()}
                                            </span>
                                        }
                                        <figcaption style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            overflow: "hidden", // 👈 keeps ellipsis responsive
                                        }}>
                                            <div style={{
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }} title={`${accountData?.userFirstName} ${accountData?.userLastName}`}> {`${accountData?.userFirstName} ${accountData?.userLastName}`}</div>
                                            <div style={{
                                                fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }} title={accountData?.accountOwner}>{accountData?.accountOwner}</div>
                                        </figcaption>
                                    </div>
                                </Text>
                            </div>
                        }
                    </div> : <div className='RightSide-DataShadow'>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "10rem"
                        }}>
                            <Spin />
                        </div>
                    </div>}
                </Panel>
            </Collapse >
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand4} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Deal</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen4 ? "Close" : "View"}</Text></div>} key="1">
                    {dealData ? <div className='RightSide-DataShadow'>
                        <div className={`user-info_image ${dealData?.DataPermission?.isPresent && "ListNavigate"}`}
                            role="button" style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
                            tabIndex={0}
                            onClick={dealData?.DataPermission?.isPresent ? () => dealData?.deals_id && ViewDetailPage(dealData?.deals_id, "DEAL") : undefined}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    ViewDetailPage(dealData?.deals_id, "DEAL")
                                }
                            }}
                        >    {dealData?.deal_profile !== null && dealData?.deal_profile
                            !== undefined && dealData?.deal_profile !== "" ?
                            <figure>
                                <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={dealData?.deal_profile} alt="" />
                            </figure>
                            :
                            <span className='list_span_Tag DealIcon' style={{ flexShrink: 0, }}>
                                {dealData?.deal_name?.slice(0, 1).toUpperCase()}
                            </span>
                            }
                            <figcaption style={{
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden", // 👈 keeps ellipsis responsive
                            }}>
                                <div style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={dealData?.deal_name}>{dealData?.deal_name}</div>
                                <div style={{
                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={dealData?.pipelineStage}>{dealData?.pipelineStage}</div>
                            </figcaption>
                        </div>
                        {(dealData?.deal_type_name && dealData?.deal_type_name !== "") ?
                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Deal Type</Text> <br />
                                <Text >{dealData?.deal_type_name}{dealData?.deal_type_name !== "Empanelment" ? "," : ""} {dealData?.subtype}</Text>
                            </div> : <></>}
                        {dealData?.pipelineStage === "Won" ?
                            (dealData?.actual_closer_date && dealData?.actual_closer_date !== "") ?
                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Acutal Closure Date</Text> <br />
                                    <Text >{dealData !== undefined && dealData.actual_closer_date && profile.dateFormate ? moment(dealData !== undefined && dealData.actual_closer_date).format(profile.dateFormate) : (dealData !== undefined && dealData.actual_closer_date && moment(dealData !== undefined && dealData.actual_closer_date).format("YYYY-MM-DD"))}</Text>
                                </div> : <></>
                            :
                            (dealData?.expected_closure_date && dealData?.expected_closure_date !== "") ?
                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Expected Closure Date</Text> <br />
                                    <Text >{dealData !== undefined && dealData.expected_closure_date && profile.dateFormate ? moment(dealData !== undefined && dealData.expected_closure_date).format(profile.dateFormate) : (dealData !== undefined && dealData.expected_closure_date && moment(dealData !== undefined && dealData.expected_closure_date).format("YYYY-MM-DD"))}</Text>
                                </div> : <></>}
                        {(dealData?.revenue_start_date && dealData?.revenue_start_date !== "") ?
                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Revenue Period</Text> <br />
                                <Text >{dealData !== undefined && dealData.revenue_start_date && profile.dateFormate ? moment(dealData !== undefined && dealData.revenue_start_date).format(profile.dateFormate) : (dealData !== undefined && dealData.revenue_start_date && moment(dealData !== undefined && dealData.revenue_start_date).format("YYYY-MM-DD"))} to {dealData !== undefined && dealData.revenue_end_date && profile.dateFormate ? moment(dealData !== undefined && dealData.revenue_end_date).format(profile.dateFormate) : (dealData !== undefined && dealData.revenue_end_date && moment(dealData !== undefined && dealData.revenue_end_date).format("YYYY-MM-DD"))}</Text>
                            </div> : <></>}
                        {(dealData?.deal_value && dealData?.deal_value !== "") ?
                            <div><Text type="secondary" className='RightSide-Lable'>Deal Value</Text> <br />
                                <Text >{currencySettings?.symbol} {dealData && dealData.deal_value && dealData.deal_value.toLocaleString()}</Text>
                            </div> : <></>
                        }
                    </div> : <div className='RightSide-DataShadow'>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "10rem"
                        }}>
                            <Spin />
                        </div>
                    </div>}
                </Panel>
            </Collapse >
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand5} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Resident</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen5 ? "Close" : "View"}</Text></div>} key="1">
                    {contactData ? <div className='RightSide-DataShadow'>
                        <div className={`user-info_image ${contactData?.DataPermission?.isPresent && "ListNavigate"}`}
                            role="button" style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
                            tabIndex={0}
                            onClick={contactData?.DataPermission?.isPresent ? () => contactData?.contacts_id && ViewDetailPage(contactData?.contacts_id, "CONTACT") : undefined}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    ViewDetailPage(contactData?.contacts_id, "CONTACT")
                                }
                            }}
                        >  {contactData?.contact_profile !== null && contactData?.contact_profile
                            !== undefined && contactData?.contact_profile !== "" ?
                            <figure>
                                <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={contactData?.contact_profile} alt="" />
                            </figure>
                            :
                            <span className='list_span_Tag ContactIcon' style={{ flexShrink: 0, }}>
                                {contactData?.first_name?.slice(0, 1).toUpperCase()}
                            </span>
                            }
                            <figcaption style={{
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden", // 👈 keeps ellipsis responsive
                            }}>
                                <div style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={`${contactData?.first_name} ${contactData?.last_name}`}>{`${contactData?.first_name} ${contactData?.last_name}`}</div>
                                <div style={{
                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={contactData?.email}>{contactData?.email}</div>
                            </figcaption>
                        </div>
                        {(contactData?.designation && contactData?.designation !== "") &&
                            <div style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                                <StaffIcon height={15} width={15} marginRight={5} />{contactData?.designation}
                            </div>}
                        {(contactData?.mobile && contactData?.mobile !== "") &&
                            <div style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                                <FeatherIcon icon="phone" size={15} style={{ display: "flex", alignItems: "center", marginRight: 5 }} />{contactData?.mobile}
                            </div>}
                    </div> : <div className='RightSide-DataShadow'>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "10rem"
                        }}>
                            <Spin />
                        </div>
                    </div>}
                </Panel>
            </Collapse >
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand2} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Invoice Owner</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen2 ? "Close" : "View"}</Text></div>} key="1">
                    <UserSideDiv userData={userData} />
                </Panel>
            </Collapse >
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", }}><div style={{ fontWeight: 600 }}>Documents<span style={{ background: "#f0f0f0", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: 500, marginLeft: "10px", }}>{displayData?.uploadFile?.length || 0}</span></div><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen ? "Close" : "View"}</Text></div>} key="1">
                    {displayData?.uploadFile?.map((file, index) => (
                        <RelatedDocs file={file} index={index} />
                    ))}
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
        </>
    );
};
NoteDetails.propTypes = {
    displayData: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    currencySettings: PropTypes.object.isRequired,
    ViewDetailPage: PropTypes.func.isRequired,
    // Role: PropTypes.string.isRequired,
};
export default NoteDetails;
